// oembedUtils.js
'use strict';
import { LRUCache } from 'lru-cache';

import { encodeUnicode } from '../resource/base64Utils.js';

const cache = new LRUCache({ max: 256 });

/**
 * Get encoded template id.
 * @param {string} {templateId} - oembed template id.
 * @return {string} Return encoded template id.
 */
export const getEncodedTemplateId = ({ templateId = '' } = {}) => {
  if (!templateId) return '';
  const key = templateId;
  let result = cache.get(key);
  if (!result) {
    result = encodeUnicode({ str: `["${templateId}",{}]` });
    cache.set(key, result);
  }
  return result;
};
